import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const IntegrationPaymentBlasterService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  service.getLineItemPaymentsByCustomerId = ({ serviceOfferingId, customerId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/lineItemPaymentRecord/serviceOfferingId/${serviceOfferingId}/customerId/${customerId}`, {
      headers,
    });
  };

  service.getLineItemPaymentRecordsByPayableId = ({ serviceOfferingId, payableId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/lineItemPaymentRecord/serviceOfferingId/${serviceOfferingId}/payableId/${payableId}`, {
      headers,
    });
  };

  return service;
})();

export default IntegrationPaymentBlasterService;
